import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { SURFACE } from "@/lib/surface";

export const ProtectedRoute = ({ children, roles, loginPath = "/login" }) => {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) return <div className="min-h-screen grid place-items-center text-white/60">Đang tải...</div>;
  if (!user) return <Navigate to={loginPath} state={{ from: loc }} replace />;
  if (roles && !roles.includes(user.role)) {
    if (SURFACE === "admin") {
      const apex = window.location.hostname.replace(/^admin\./, "");
      const playerHost = apex.startsWith("app.") ? apex : apex;
      return (
        <div className="min-h-screen grid place-items-center bg-[#05050a] px-6">
          <div className="max-w-md w-full rounded-2xl bg-[#0c0d14] border border-red-500/30 p-6 text-center">
            <h1 className="font-display font-black text-xl mb-2">Không có quyền truy cập</h1>
            <p className="text-sm text-white/60 mb-4">
              Trang này chỉ dành cho quản trị viên. Bạn đang đăng nhập bằng tài khoản người chơi.
            </p>
            <a
              href={`${window.location.protocol}//${playerHost}/`}
              className="inline-block px-5 py-2.5 rounded-md bg-amber-400/90 text-black font-display font-bold text-sm"
            >
              Quay về App người chơi
            </a>
          </div>
        </div>
      );
    }
    return <div className="min-h-screen grid place-items-center text-white/60">Bạn không có quyền truy cập trang này.</div>;
  }
  return children;
};

export default ProtectedRoute;
